import { gql } from '@apollo/client';

export const GET_EMPLOYEE_APP_RATING = gql`
  query GetEmployeeAppRating($userId: ID!) {
    appRatings(where: { hotelEmployee: $userId }, limit: 1) {
      id
    }
  }
`;
